import personsData from '../data/persons.json';


const processPersonsData = (data) => {
    const allPersons = [];
    Object.keys(data).forEach(category => {
        data[category].forEach(person => {
            allPersons.push({ ...person, category });
        });
    });
    return allPersons;
};


const initialPersons = processPersonsData(personsData);

export function usePersons() {

    return { persons: initialPersons, loading: false, error: null };
}

